import React, { useState } from 'react';
import ConfirmModal from 'shared/components/ConfirmModal';
import { toast } from 'react-toastify';
import api from 'shared/services/api';
import { useTranslations } from 'shared/translations/useTranslations';

const DeleteFileModal = ({ recommendationId, fileId, isOpen, onClose, onSuccess }) => {
  const translations = useTranslations();
  const [isLoading, setLoading] = useState<boolean>();
  const onDelete = async () => {
    try {
      setLoading(true);
      await api({}).delete(`/api/recommendations/${recommendationId}/files/${fileId}`);
      onClose();
      setLoading(false);
      onSuccess();
      toast.success(translations.global.attachmentDeteleted);
    } catch {
      setLoading(false);
      toast.error(translations.global.somethingWentWrong);
    }
  };
  return (
    <>
      <ConfirmModal
        isOpen={isOpen}
        paragraph={<div>{translations.global.deleteAttachmentConfirmation}</div>}
        isLoading={isLoading}
        onClose={() => onClose()}
        onConfirm={onDelete}
        title={translations.global.deleteAttachment}
        confirmLabel={translations.global.delete}
        cancelLabel={translations.global.cancel}
      />
    </>
  );
};

export default DeleteFileModal;
